//CSS
import './App.scss';
import './assets/scss/gallery.scss';

//External Components
import React from "react";
import {
    BrowserRouter as Router, Switch
} from "react-router-dom";

//Context
import { DataProvider } from "./dataContext";

//Routes
import PrivateRoute from "./Routes/PrivateRoute";
import PublicRoutes from "./Routes/PublicRoutes";

//Pages
import Login from "./Pages/Login";
import Creation from "./Pages/Creation";
import Dashboard from "./Pages/Dashboard";
import Map from './Pages/Map';
import error404 from "./Pages/404";
import Planning from "./Pages/Planning";
import Reset from "./Pages/Reset";
import ResetPassword from "./Pages/ResetPassword";
import Clients from "./Pages/Clients";
import Concierges from "./Pages/Concierges";
import Users from "./Pages/Users";
import Providers from "./Pages/Providers";
import Billing from "./Pages/Billing";
import Archives from './Pages/Archives';
import Gestion from './Pages/Gestion';
import Secteurs from './Pages/Secteurs';
import Products from './Pages/Billing/Products';
import Contacts from './Pages/Billing/Contacts';

//Modal
import ErrorModal from "./Components/Modals/ErrorModal";
import Invoices from './Pages/Billing/Invoices';
import Bills from './Pages/Billing/Bills';
import Statistics from './Pages/Statistics';

//Base Constant
const baseURL = document.getElementsByTagName('base')[0].getAttribute('href');
const billingOnly = process.env.REACT_APP_BILLING_ONLY === "true";

function App() {
    return (
        <DataProvider>
            <Router forceRefresh={false}
                basename={baseURL}>
                <div id={"app"}>
                    <Switch>
                        <PublicRoutes path={'/login'} exact component={Login} />
                        <PublicRoutes path={'/creation/:token'} exact component={Creation} />
                        <PublicRoutes path={'/reset'} exact component={Reset} />
                        <PublicRoutes path={'/reset/:token'} exact component={ResetPassword} />
                        {billingOnly
                            ? <PrivateRoute path={'/'} exact component={Bills} />
                            : <PrivateRoute path={'/'} exact component={Dashboard} />}
                        {!billingOnly && <PrivateRoute path={'/map'} exact component={Map} />}
                        {!billingOnly && <PrivateRoute path={'/clients'} exact component={Clients} />}
                        {!billingOnly && <PrivateRoute path={'/concierges'} exact component={Concierges} />}
                        {!billingOnly && <PrivateRoute path={'/team'} exact component={Users} />}
                        <PrivateRoute path={'/billing'} exact component={Billing} />
                        {!billingOnly && <PrivateRoute path={'/providers'} exact component={Providers} />}
                        {!billingOnly && <PrivateRoute path={'/planning'} exact component={Planning} />}
                        {!billingOnly && <PrivateRoute path={'/archives'} exact component={Archives} />}
                        {!billingOnly && <PrivateRoute path={'/gestion'} exact component={Gestion} />}
                        {!billingOnly && <PrivateRoute path={'/secteurs'} exact component={Secteurs} />}
                        <PrivateRoute path={'/billing/products'} exact component={Products} />
                        <PrivateRoute path={'/billing/contacts'} exact component={Contacts} />
                        <PrivateRoute path={"/billing/invoices"} exact component={Invoices} />
                        <PrivateRoute path={"/billing/bills"} exact component={Bills} />
                        {!billingOnly && <PrivateRoute path={"/statistics"} exact component={Statistics} />}
                        <PrivateRoute component={error404} />
                    </Switch>
                </div>
            </Router>
            <ErrorModal />
        </DataProvider>
    );
}

export default App;
